import { AxiosResponse } from "axios";
import { api } from "./utils/axios";
import { userStore } from "@/stores/UserStore";
import { authStore } from "@/stores/AuthStore";
export interface UniversalServicesResponse<D> {
  success: boolean;
  message?: string;
  data?: D;
}

export class UniversalServices {
  constructor() {}

  async getData<D>(
    url: string,
    action: string,
    //eslint-disable-next-line
    data?: any,
    method: "post" | "get" = "post",
  ): Promise<UniversalServicesResponse<D>> {
    const finalUrl = `${url}/${action}`;

    try {
      let response: AxiosResponse<UniversalServicesResponse<D>>;

      if (method === "get") {
        response = await api.get(finalUrl, { params: data });
      } else {
        response = await api.post(finalUrl, data);
      }

      if (
        response.data.message === "Вы не авторизованы" &&
        userStore.isAuthenticated &&
        localStorage.getItem("api_token")
      ) {
        authStore.checkAuth();
      }

      return response.data;

      //eslint-disable-next-line
    } catch (error: any) {
      return {
        success: false,
        message: error.message || "Ошибка сервера",
      };
    }
  }
}

export const universalServices = new UniversalServices();
